var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ _vm.isTeacher ? 'teacher-view' : 'student-view' ]},[_c('headerComponent'),_vm._v(" "),_c('div',{staticClass:"size margin",class:{ 'size--ec': _vm.isEC }},[_c('div',{staticClass:"animation-bottom animation-delay-01"},[_c('subTopicTemplate',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var topic = ref.topic;
var subTopic = ref.subTopic;
return [_c('completePhrase',{ref:"game",attrs:{"topic":topic,"subTopic":subTopic}})]}}])})],1)]),_vm._v(" "),_c('modalPdf')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-447de344","hasScoped":false,"transformToRequire":{"video":["src","poster"],"audio":["src"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test/index.vue
// module id = 1422
// module chunks = 2